import { Alert, Typography } from "@mui/material";
import { t } from "i18next";
import { formatCurrency, getInstructionByPaymentProvider } from "../../utils";
import OutcomeCard from "./OutcomeCard";

const LoadingCard = ({
  totalAmount,
  currency,
  phoneNumber,
}: {
  totalAmount: string;
  // The unit the pay response named. Absent on a reload, where the session
  // holds neither the amount nor its unit.
  currency?: string;
  phoneNumber?: string;
}) => (
  <OutcomeCard
    tone="pending"
    eyebrow={t("stepper_3.please_wait")}
    title={t("stepper_3.waiting_payment")}
  >
    <Typography sx={{ fontSize: 15, color: "text.secondary" }}>
      {t("stepper_3.payment_notif")}
    </Typography>
    {Number(totalAmount) > 0 && (
      <Typography sx={{ fontSize: 32, fontWeight: 800, my: 2 }}>
        {formatCurrency(totalAmount, undefined, currency)}
      </Typography>
    )}
    <Typography sx={{ fontSize: 14, color: "text.secondary" }}>
      {t(getInstructionByPaymentProvider(phoneNumber))}
    </Typography>
    {/* The page polls for the result; leaving it loses the outcome,
        not the payment, and the payer cannot tell the two apart. */}
    <Alert severity="warning" sx={{ mt: 3, textAlign: "left" }}>
      {t("stepper_3.do_not_close")}
    </Alert>
  </OutcomeCard>
);

export default LoadingCard;
